import {
	type QueryKey,
	type UseQueryOptions,
	useQuery,
} from "@tanstack/react-query";
import { useIsAuthenticated } from "../../packages/auth";
import { useReadUserVehicleService } from "../../services/user-vehicle";
import type { GetUserVehiclesRawResponse } from "../../services/user-vehicle/validation/GetVehicles/index.types";

const useRawUserVehicles = <
	TQueryFnData = GetUserVehiclesRawResponse | undefined,
	TError = Error,
	TData = TQueryFnData,
	TQueryKey extends QueryKey = ("user-vehicles" | boolean | undefined)[],
>(
	options?: Omit<
		UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
		"queryKey" | "queryFn"
	>,
) => {
	const isAuthenticated = useIsAuthenticated();
	const service = useReadUserVehicleService();

	const query = useQuery<TQueryFnData, TError, TData, TQueryKey>({
		enabled: isAuthenticated,
		queryFn: async ({ signal }) => {
			const { data } = await service.find({ signal });
			return data as TQueryFnData;
		},
		queryKey: ["user-vehicles", isAuthenticated] as unknown as TQueryKey,
		...options,
	});

	return {
		...query,
		isLoading: query.isLoading && query.fetchStatus !== "idle",
	};
};

export default useRawUserVehicles;
